export const PERMISSIONS = {
  TRANGCHU: 'TRANGCHU',

  // Thanh tra
  QLKLKNTHANHTRA: 'QLKLKNTHANHTRA',
  QLKLKNTHANHTRA_DANHSACH: 'QLKLKNTHANHTRA_DANHSACH',
  QLKLKNTHANHTRA_CAPNHAT: 'QLKLKNTHANHTRA_CAPNHAT',
  THUCHIENKIENNGHI_THANHTRA_XEM: 'THUCHIENKIENNGHI_THANHTRA_XEM',
  THUCHIENKIENNGHI_THANHTRA_CAPNHAT: 'THUCHIENKIENNGHI_THANHTRA_CAPNHAT',
  THUCHIENKIENNGHI_THANHTRA_XOA: 'THUCHIENKIENNGHI_THANHTRA_XOA',
  THEODOIKIENNGHI_THANHTRA: 'THEODOIKIENNGHI_THANHTRA',

  // Kiểm toán
  QLKLKNKIEMTOAN: 'QLKLKNKIEMTOAN',
  QLKLKNKIEMTOAN_DANHSACH: 'QLKLKNKIEMTOAN_DANHSACH',
  QLKLKNKIEMTOAN_CAPNHAT: 'QLKLKNKIEMTOAN_CAPNHAT',
  THUCHIENKIENNGHI_KIEMTOAN_XEM: 'THUCHIENKIENNGHI_KIEMTOAN_XEM',
  THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT: 'THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT',
  THUCHIENKIENNGHI_KIEMTOAN_XOA: 'THUCHIENKIENNGHI_KIEMTOAN_XOA',
  THEODOIKIENNGHI_KIEMTOAN: 'THEODOIKIENNGHI_KIEMTOAN',

  // Theo dõi tất cả
  THEODOIKETLUAN_XEMTATCA: 'THEODOIKETLUAN_XEMTATCA',
  KETLUANTHANHTRA_XEMTATCA: 'KETLUANTHANHTRA_XEMTATCA',
  KIENNGHITHANHTRA_XEMTATCA: 'KIENNGHITHANHTRA_XEMTATCA',
  KETLUANKIEMTOAN_XEMTATCA: 'KETLUANKIEMTOAN_XEMTATCA',
  KIENNGHIKIEMTOAN_XEMTATCA: 'KIENNGHIKIEMTOAN_XEMTATCA',

  // Danh mục
  DANHMUC: 'DANHMUC',
  DM_NHOMDOITUONG_DANHSACH: 'DM_NHOMDOITUONG_DANHSACH',
  DM_NHOMDOITUONG_CAPNHAT: 'DM_NHOMDOITUONG_CAPNHAT',
  DM_DOITUONGTHANHTRA_DANHSACH: 'DM_DOITUONGTHANHTRA_DANHSACH',
  DM_DOITUONGTHANHTRA_CAPNHAT: 'DM_DOITUONGTHANHTRA_CAPNHAT',
  DM_DOITUONGTHANHTRA_KHONGCANXACNHAN: 'DM_DOITUONGTHANHTRA_KHONGCANXACNHAN',
  DM_LOAIKETLUAN_DANHSACH: 'DM_LOAIKETLUAN_DANHSACH',
  DM_LOAIKETLUAN_CAPNHAT: 'DM_LOAIKETLUAN_CAPNHAT',
  DM_LINHVUCVIPHAM_DANHSACH: 'DM_LINHVUCVIPHAM_DANHSACH',
  DM_LINHVUCVIPHAM_CAPNHAT: 'DM_LINHVUCVIPHAM_CAPNHAT',
  DM_LOAIKIEMTOAN_DANHSACH: 'DM_LOAIKIEMTOAN_DANHSACH',
  DM_LOAIKIEMTOAN_CAPNHAT: 'DM_LOAIKIEMTOAN_CAPNHAT',
  DM_LOAICHIPHI_DANHSACH: 'DM_LOAICHIPHI_DANHSACH',
  DM_LOAICHIPHI_CAPNHAT: 'DM_LOAICHIPHI_CAPNHAT',
  DM_LOAINGUONVON_DANHSACH: 'DM_LOAINGUONVON_DANHSACH',
  DM_LOAINGUONVON_CAPNHAT: 'DM_LOAINGUONVON_CAPNHAT',
  DM_DUAN_DANHSACH: 'DM_DUAN_DANHSACH',
  DM_DUAN_CAPNHAT: 'DM_DUAN_CAPNHAT',
  DM_HINHTHUCXULY_DANHSACH: 'DM_HINHTHUCXULY_DANHSACH',
  DM_HINHTHUCXULY_CAPNHAT: 'DM_HINHTHUCXULY_CAPNHAT',
  DM_HINHTHUCKIENNGHI_DANHSACH: 'DM_HINHTHUCKIENNGHI_DANHSACH',
  DM_HINHTHUCKIENNGHI_CAPNHAT: 'DM_HINHTHUCKIENNGHI_CAPNHAT',
  SAOLUUBACKUP_XEM: 'SAOLUUBACKUP_XEM',
  SAOLUUBACKUP_CAPNHAT: 'SAOLUUBACKUP_CAPNHAT',
  HETHONG: 'HETHONG',

  // Báo cáo động
  BAOCAOTHONGKEDONG: 'BAOCAOTHONGKEDONG',
  BAOCAOTHONGKE: 'BAOCAOTHONGKE',

  //Bao cao thong ke moi
  BAOCAOTHONGKE_MOI: 'BCTKKLTHANHTRAKIEMTOAN'
}
